module.exports = __webpack_public_path__ + "img/shoulders.60ecf0c4.png";